module.exports = __webpack_public_path__ + "media/images/help/cb-license-agree-eb4528964ba795f7a56167b1f6dd4fd9.png";